import {NodeHtmlMarkdown} from "node-html-markdown";

export class HtmlToMarkdownConverter {
    public toMarkdown(html: string): string {
        return NodeHtmlMarkdown.translate(html, {
            strongDelimiter: '*',
            strikeDelimiter: '~',
            bulletMarker: '-'
        });
    }
}